import './DownloadPDFButton.css';

const DownloadPDFButton = () => {
  const pdfUrl = "https://fqodzpifyovgmqjlluin.supabase.co/storage/v1/object/public/pdfs/XPRIZE_Phase_I_Submission_Snowdrop.pdf";

  return (
    <a
      href={pdfUrl}
      download="XPRIZE_Phase_I_Submission_Snowdrop.pdf"
      className="download-button"
    >
      Download X-Prize Phase 1 Submission
    </a>
  );
};

export default DownloadPDFButton;